var $c31b5e8e9a249fd5$exports = {};
$c31b5e8e9a249fd5$exports = {
    "Empty": `Prazno`
};


export {$c31b5e8e9a249fd5$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
